import {AbstractControl} from '@angular/forms';

export function PhoneNumberRequiredValidator(control: AbstractControl) {
    if (!control.value || control.value.length <= 2) {
        return {
            phoneNumberRequired: true
        };
    }

    return null;
}
